export default {
  "content": "<path d=\"M0 0h48v48H0z\" fill=\"none\"/><g fill=\"#3F4450\"><circle cx=\"31.5\" cy=\"21.5\" r=\"1.5\"/><circle cx=\"24.5\" cy=\"21.5\" r=\"1.5\"/><circle cx=\"17.5\" cy=\"21.5\" r=\"1.5\"/><path d=\"M42 5H7C5.346 5 4 6.346 4 8v27c0 1.654 1.346 3 3 3h5v4a1.002 1.002 0 001.641.768L19.362 38H42c1.654 0 3-1.346 3-3V8c0-1.654-1.346-3-3-3zm1 30c0 .551-.448 1-1 1H19c-.234 0-.461.082-.641.232L14 39.865V37a1 1 0 00-1-1H7c-.552 0-1-.449-1-1V8c0-.551.448-1 1-1h35c.552 0 1 .449 1 1z\"/></g>",
  "attrs": {
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};